
import { Opacity } from '@mui/icons-material';
import { createTheme } from '@mui/material/styles';

export const cubictheme = createTheme({
  palette: {
    primary: {
      main: '#00548b'
    },
    secondary: {
      main: '#fff'
    },
    

  },
  transitions: {
    easing: {
      // This is the most common easing curve.
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      // Objects enter the screen at full velocity from off-screen and
      // slowly decelerate to a resting point.
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      // Objects leave the screen at full velocity. They do not decelerate when off-screen.
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      // The sharp curve is used by objects that may return to the screen at any time.
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      // most basic recommended timing
      standard: 300,
      // this is to be used in complex animations
      complex: 375,
      // recommended when something is entering screen
      enteringScreen: 225,
      // recommended when something is leaving screen
      leavingScreen: 195,
    },
  },
  components: {
    MuiSelect: {
      styleOverrides:{
      root: {"&.smallpadding .MuiInputBase-inputSizeSmall":{
        padding: "4px 32px 4px 16px !important"
      }
      }
    }
    },
    MuiListItemButton: {
      styleOverrides:
      {
        // root:    {"&.Mui-selected": {
        //   backgroundColor: "#00548b",
        //   color: "#fff"
        // }
        // }

      }
    },
    MuiButton:{
      defaultProps: {
        disableElevation: true, // Disables elevation for all buttons
      },
      styleOverrides:{
        root:{
          textTransform:'none',
          " .MuiButton-startIcon":{
          margin:0,
        },
        "&.MuiButton-outlined.Mui-disabled":{
          backgroundColor: '#fff',
          borderColor: '#00548b35',
          Opacity:0.4,
          cursor:"not-allowed"
        },
        "&.MuiButton-contained.Mui-disabled":{
          backgroundColor: '#00548b80',
          cursor:"not-allowed"
        }

        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          '&.MuiMultiSectionDigitalClockSection-root': {
            width: '100px',
            '.MuiMenuItem-root': {
              width: '80px'
              },
            },
          },
        },
      },
    
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: 0,
          fontWeight:'bold',
          fontSize:'16px',
          borderRadius: '5px'
        }

      }
    },
    MuiCard:{
      defaultProps:{
        elevation:0
      }
    },
    MuiPaper:{
      defaultProps:{
        elevation:0
      }
    },
    MuiStepConnector:{
      styleOverrides:{
        root:{
          maxWidth:50
        }
      }
    },
    MuiStepper:{
      styleOverrides:{
        root:{
          width:'100%',
          display:'flex',
          justifyContent:'center'
        }
      }
    }

  }
});

